import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
  open: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
  title: string;
  disclaimer: string;
  downloadButton: () => Promise<void>;
  buttonText?: string;
}
export const ConfirmDownload: FC<Props> = ({ open, setClose, title, disclaimer, downloadButton, buttonText }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    setClose(false);
  };

  const handleDownload = () => {
    downloadButton();
    handleClose();
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{disclaimer}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('issuer.legalDialog.cancel')}</Button>
          <Button onClick={handleDownload} variant="contained" autoFocus>
            {buttonText ?? t('issuer.legalDialog.download')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
